export const buildSingleOCRPayload = ({
  documentType,
  tabData = null,
  passport,
  paymentCards,
  boardingPassFiles,
  tripAir,
  tripSea,
  ActiveTripType,
  purchaseReceipts,
  id,
  currentTab
}) => {
  const normalizeFileObject = file => {
    if (!file) return null
    if (file.file_obj || file) return file.file_obj || file
    if (file.document_revision_id) return file
    return null
  }

  const getDocumentRevisionId = fileObj => {
    if (!fileObj) return null
    return fileObj.document_revision_id
  }

  const documents = []

  if (documentType === 'Passport' && passport?.files?.length > 0) {
    const passportDocuments = passport.files
      .filter(
        file =>
          file?.file_obj?.document_revision_id || file?.document_revision_id
      )
      .map(
        file =>
          file.file_obj?.document_revision_id || file?.document_revision_id
      )

    if (passportDocuments.length > 0) {
      documents.push({
        type: 'passport',
        document_id:
          passportDocuments.length === 1
            ? passportDocuments[0]
            : passportDocuments,
        record_id: passport.id
      })
    }
  } else if (
    (/^\d{4}$/.test(documentType) || documentType.startsWith('Card')) &&
    paymentCards?.length > 0
  ) {
    let currentCard

    if (/^\d{4}$/.test(documentType)) {
      const lastFourDigits = documentType
      currentCard = paymentCards.find(card => {
        const cardNumber = card.attributes?.card_number || ''
        return cardNumber.replace(/\D/g, '').slice(-4) === lastFourDigits
      })
    } else if (documentType.startsWith('Card ')) {
      const cardMatch = documentType.match(/Card (.+)/)
      if (cardMatch) {
        const cardIdentifier = cardMatch[1]
        if (/^\d{4}$/.test(cardIdentifier)) {
          const lastFourDigits = cardIdentifier
          currentCard = paymentCards.find(card => {
            const cardNumber = card.attributes?.card_number || ''
            return cardNumber.replace(/\D/g, '').slice(-4) === lastFourDigits
          })
        } else if (/^\d+$/.test(cardIdentifier)) {
          const index = parseInt(cardIdentifier) - 1
          currentCard = paymentCards[index]
        }
      }
    }

    if (currentCard && currentCard.files?.length > 0) {
      const cardDocuments = currentCard.files
        .filter(
          file =>
            file?.file_obj?.document_revision_id || file?.document_revision_id
        )
        .map(
          file =>
            file.file_obj?.document_revision_id || file?.document_revision_id
        )

      if (cardDocuments.length > 0) {
        documents.push({
          type: 'credit_card',
          document_id:
            cardDocuments.length === 1 ? cardDocuments[0] : cardDocuments,
          record_id: currentCard.attributes?.id
        })
      }
    }
  } else if (documentType === 'Boarding Pass' && boardingPassFiles?.[0]) {
    const normalizedFile = normalizeFileObject(boardingPassFiles[0])
    const documentId = getDocumentRevisionId(normalizedFile)
    if (documentId) {
      documents.push({
        type: 'boarding_pass',
        document_id: documentId,
        record_id: tripAir?.attributes?.id
      })
    }
  } else if (
    documentType === 'Cruise ID' &&
    (tripSea?.files?.cruise?.[0] || tripAir?.files?.cruise?.[0])
  ) {
    const cruiseFiles =
      ActiveTripType === 'air' ? tripAir?.files?.cruise : tripSea?.files?.cruise
    const normalizedFile = normalizeFileObject(cruiseFiles?.[0])
    const documentId = getDocumentRevisionId(normalizedFile)
    if (documentId) {
      documents.push({
        type: 'cruise_id',
        document_id: documentId,
        record_id:
          ActiveTripType === 'air' ? tripAir?.attributes?.id : tripSea?.id
      })
    }
  } else if (documentType === 'POS' && tabData?.purchaseId) {
    const purchase = purchaseReceipts?.find(
      pr => pr.attributes?.id === tabData.purchaseId
    )
    if (purchase?.files?.pos_receipt?.[0]) {
      const normalizedFile = normalizeFileObject(purchase.files.pos_receipt[0])
      const documentId = getDocumentRevisionId(normalizedFile)
      if (documentId) {
        documents.push({
          type: 'pos_receipt',
          document_id: documentId,
          record_id: tabData.purchaseId
        })
      }
    }
  } else if (tabData?.purchaseId) {
    let documentType = ''
    const purchase = purchaseReceipts?.find(
      pr => pr.attributes?.id === tabData.purchaseId
    )
    if (purchase?.payment_methods?.[tabData?.paymentMethodIndex]?.attributes?.last_digits) {
      documentType = purchase?.payment_methods?.[tabData?.paymentMethodIndex]?.attributes?.last_digits
    } else if (!documentType) {
      documentType = `CC Slip ${tabData?.paymentMethodIndex + 1}`
    }

    if (documentType) {
      const paymentMethodIndex = tabData?.paymentMethodIndex || 0

      if (purchase?.payment_methods?.[paymentMethodIndex]?.files?.slip?.[0]) {
        const normalizedFile = normalizeFileObject(
          purchase.payment_methods[paymentMethodIndex].files.slip[0]
        )
        const documentId = getDocumentRevisionId(normalizedFile)
        if (documentId) {
          documents.push({
            type: 'credit_card_receipt',
            document_id: documentId,
            record_id: purchase.payment_methods[paymentMethodIndex].attributes?.id
          })
        }
      }
    }


  } else if (documentType === 'Factura' && tabData?.purchaseId) {
    // Not supported yet
    return null
  }

  if (documents.length === 0) return null

  return {
    contact_id: id,
    documents
  }
}

const flattenCreditCardResult = result => {
  return Array.isArray(result?.cards) && result.cards.length > 0
    ? result.cards.map((card, index) => ({
      ...card,
      record_id: card?.record_id || result?.record_ids?.[index]
    }))
    : [result]
}
export const buildCardCheckOverrides = ocrApiResponse => {
  const toFlag = value => (value ? '1' : '0')
  const results =
    ocrApiResponse?.data?.results || ocrApiResponse?.results || []
  const creditCardResults = Array.isArray(results)
    ? results.filter(result => result?.type === 'credit_card')
    : []
  return creditCardResults.reduce((acc, result) => {
    flattenCreditCardResult(result).forEach(card => {
      const cardId = card?.record_id
      if (!cardId) return
      acc[cardId] = {
        luhn_check: toFlag(card?.data?.luhn_check?.value?.valid),
        bin_check: toFlag(card?.data?.bin_check?.value?.valid),
        ocr_status: toFlag(card?.success),
        redaction_verified: toFlag(card?.redaction_verified)
      }
    })
    return acc
  }, {})
}
